import { FC, useEffect } from 'react';

const GoogleAnalytics: FC = () => {
  useEffect(() => {
    const script: HTMLScriptElement = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-0TPS4R8GCP';
    script.async = true;

    const _window = window as any;

    script.onload = () => {
      _window.dataLayer = _window.dataLayer || [];
      const gtag = (x: any, y: any) => {
        _window.dataLayer.push(x, y);
      };
      gtag('js', new Date());
      gtag('config', 'G-0TPS4R8GCP');
    };

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
};

export default GoogleAnalytics;
